/**
 * Analytics-domain slice of the umbrella runtime config.
 *
 * The injection mechanism + window global lives in
 * `lib/runtime-config.ts` (one umbrella for every runtime config
 * domain). This file owns the analytics SHAPE + the domain-specific
 * reader; everything else (server-side env reading, SSR injection,
 * empty defaults) is centralised one level up so we don't have N
 * parallel `<script>` tags for N domains.
 */

import { getRuntimeConfig } from '../runtime-config';

export interface AnalyticsConfig {
  gaId: string;
  googleAdsId: string;
  gadsConversions: Record<string, string>;
  umamiUrl: string;
  umamiWebsiteId: string;
  appVersion: string;
}

export function getAnalyticsConfig(): AnalyticsConfig {
  return getRuntimeConfig().analytics;
}
